// External deps
import { Button, ContentCard, Input, InputPassword } from 'ypf-pas-general-ui-components';
import { Form } from "react-bootstrap";
import { useFormik } from "formik";
import * as yup from "yup";

// Internal deps
import { login } from "../../adapters/loginAdapter";
import logo from "../../assets/logo-yclick-2.svg";
import useApp from "../../hooks/useApp";
import useLoading from "../../hooks/useLoading";
import { showError } from "../../utils/toastUtils";

import "./LoginContainer.scss";

const schemaFilters = yup.object().shape({
  user: yup
    .string()
    .required("Debe ingresar usuario")
    .max(50, "Se permite hasta 50 caracteres")
    .min(5, "Debe ingresar al menos 5 caracteres"),
  password: yup
    .string()
    .required("Debe ingresar contraseña")
    .max(50, "Se permite hasta 50 caracteres")
    .min(5, "Debe ingresar al menos 5 caracteres"),
});

const LoginContainer = () => {
  const { authUser } = useApp();
  const { setLoading } = useLoading();

  const loginUser = ({ user, password }) => {
    setLoading(true);
    login({
      user,
      password,
    })
      .then((responseLogin) => {
        const accessTokenData = {
          access_token: responseLogin.accessToken,
          refresh_token: responseLogin.refreshToken,
          expires_in: responseLogin.expiresIn,
        };
        authUser(accessTokenData, new Date().getTime());
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        showError(err);
      });
  };

  const formik = useFormik({
    initialValues: {
      user: "",
      password: "",
    },
    onSubmit: (newValues) => loginUser(newValues),
    validationSchema: schemaFilters,
  });

  const { values, setFieldValue, handleSubmit, isValid } = formik;

  return (
    <div className="login-page">
      <div className="centered-container">
        <img src={logo} alt="Logo-Yclick" />
        <ContentCard orientation="horizontal">
          <Form onSubmit={handleSubmit} className="text-center w-100">
            <h4>Bienvenido</h4>
            <Input
              label="Usuario"
              type="text"
              name="user"
              placeholder="Ingrese usuario"
              onChange={(e) => {
                setFieldValue("user", e.target.value?.trim());
              }}
              value={values.user}
              maxLength={50}
            />
            <InputPassword
              label="Contraseña"
              name="password"
              placeholder="Ingrese contraseña"
              className="mt-3 mb-1"
              onChange={(e) => {
                setFieldValue("password", e.target.value?.trim());
              }}
              value={values.password}
              maxLength={50}
              showIcon
            />
            <div className="forget-password d-flex justify-content-start mb-3">
              <a
                href="https://ssofed.ypf.com/ufpw/recupero_clave_cp"
                target="a_blank"
              >
                <span>¿Olvidaste tu contraseña?</span>
              </a>
            </div>
            <Button
              variant="primary"
              type="submit"
              label="Ingresar"
              className="my-2"
              widthButton="100%"
              disabled={!isValid}
            />
          </Form>
        </ContentCard>
      </div>
    </div>
  );
};

export default LoginContainer;
